import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { clearState } from './logout-reducer';

import { refReducer } from './reference-number.reducer';
import { persDetailsReducer } from './personal-details.reducer';
import { regsDetailsReducer } from './registration-details.reducer';
import { BeforeStartReducer } from './before-start.reducer';
import { depDetailsReducer } from './dependant-details.reducer';
import { YourPensionReducer } from './your-pension.reducer';
import { QuoteCaptureReducer } from './response-quote-datacapture.reducer';
import { QuoteCalculationReducer } from './response-quote-calculation.reducer';
import { ProductChoiceReducer } from './product-choice.reducer';
import { ReqQuoteCalculationReducer } from './request-quote-calculation.reducer';
import { QuoteResultReducer } from './quote-result.reducer';
import { LoggedinDetailReducer } from './loggedin-detail.reducer';
import { QuotePlaybackRiskWarningReducer } from './playback-risk-warnings.reducer';
import { LifestyleReducer } from '../../pages/medical-underwriting/store/reducers/lifestyle.reducer';
import { MedicalConditionReducer } from '../../pages/medical-underwriting/store/reducers/medical-condition.reducer';
import { InitialQuestionReducer } from '../../pages/medical-underwriting/store/reducers/initial-question.reducer';
import { ActivitiesOfDailyLivingReducer } from '../../pages/medical-underwriting/store/reducers/activities-of-daily-living.reducer';
import { paymentDetailsReducer } from './payment-details.reducer';
import { ClearToApplyReducer } from './clear-to-apply.reducer';
import { healthRecordsReducer } from './health-records.reducer';
import { depHealthReducer } from './dep-health-records.reducer';
import { YourDependantDetailsReducer } from './your-dependant-detail.reducer';
import { YourPersonalDetailsReducer } from './your-personal-details.reducer';
import { GuidanceAndAdviceReducer } from './guidance-and-advice.reducer';
import { BeneficiaryDetailsReducer } from './beneficiary-details.reducer';
import { ResponseApplicationModalReducer } from './response-applicationDataCapture.reducer';
import { YourProductApplicationReducer } from './your-product-application.reducer';
import { pensionSavingsReducer } from './your-pension-savings.reducer';
import { UnderWritingDataReducer } from '../../pages/medical-underwriting/store/reducers/underwriting-ho.reducer';
import { YourLumpSumAllowancesReducer } from './your-lump-sum-allowances.reducer';
import { cardRefreshReducer } from '../reducers/card-refresh.reducers';
import { PensionProvidersListReducer } from './pension-providers-lsit.reducer';

export interface AppState {
    cardRefresh: ReturnType<typeof cardRefreshReducer>;
    refno: ReturnType<typeof refReducer>;
    personalDetails: ReturnType<typeof persDetailsReducer>;
    registrationDetails: ReturnType<typeof regsDetailsReducer>;
    beforeStart: ReturnType<typeof BeforeStartReducer>;
    dependantDetails: ReturnType<typeof depDetailsReducer>;
    yourpension: ReturnType<typeof YourPensionReducer>;
    quoteCapture: ReturnType<typeof QuoteCaptureReducer>;
    quoteCalculation: ReturnType<typeof QuoteCalculationReducer>;
    productChoice: ReturnType<typeof ProductChoiceReducer>;
    reqQuoteCalculation: ReturnType<typeof ReqQuoteCalculationReducer>;
    quoteResult: ReturnType<typeof QuoteResultReducer>;
    loggedinDetail: ReturnType<typeof LoggedinDetailReducer>;
    quotePlaybackRiskWarning: ReturnType<typeof QuotePlaybackRiskWarningReducer>;
    lifeStyle: ReturnType<typeof LifestyleReducer>;
    medicalCondtion: ReturnType<typeof MedicalConditionReducer>;
    initialQuestion: ReturnType<typeof InitialQuestionReducer>;
    activitiesOfDailyLiving: ReturnType<typeof ActivitiesOfDailyLivingReducer>;
    bankDetails: ReturnType<typeof paymentDetailsReducer>;
    clearApply: ReturnType<typeof ClearToApplyReducer>;
    yourPersonalDetails: ReturnType<typeof YourPersonalDetailsReducer>;
    beneficiaryDetails: ReturnType<typeof BeneficiaryDetailsReducer>;
    annuitantDoctorDetails: ReturnType<typeof healthRecordsReducer>;
    dependantDoctorDetails: ReturnType<typeof depHealthReducer>;
    yourDependantDetails: ReturnType<typeof YourDependantDetailsReducer>;
    applicationDataResponse: ReturnType<typeof ResponseApplicationModalReducer>;
    yourProductApplication: ReturnType<typeof YourProductApplicationReducer>;
    pensionSavings: ReturnType<typeof pensionSavingsReducer>;
    underwritingDataHO: ReturnType<typeof UnderWritingDataReducer>;
    guidanceAndAdvice: ReturnType<typeof GuidanceAndAdviceReducer>;
    yourLumpSumAllowances: ReturnType<typeof YourLumpSumAllowancesReducer>;
    ppList: ReturnType<typeof PensionProvidersListReducer>;

}

export const reducers: ActionReducerMap<AppState> = {
    cardRefresh: cardRefreshReducer,
    refno: refReducer,
    personalDetails: persDetailsReducer,
    registrationDetails: regsDetailsReducer,
    beforeStart: BeforeStartReducer,
    dependantDetails: depDetailsReducer,
    yourpension: YourPensionReducer,
    quoteCapture: QuoteCaptureReducer,
    quoteCalculation: QuoteCalculationReducer,
    productChoice: ProductChoiceReducer,
    reqQuoteCalculation: ReqQuoteCalculationReducer,
    quoteResult: QuoteResultReducer,
    loggedinDetail: LoggedinDetailReducer,
    quotePlaybackRiskWarning: QuotePlaybackRiskWarningReducer,
    lifeStyle: LifestyleReducer,
    medicalCondtion: MedicalConditionReducer,
    initialQuestion: InitialQuestionReducer,
    activitiesOfDailyLiving: ActivitiesOfDailyLivingReducer,
    bankDetails: paymentDetailsReducer,
    clearApply: ClearToApplyReducer,
    yourPersonalDetails: YourPersonalDetailsReducer,
    beneficiaryDetails: BeneficiaryDetailsReducer,
    annuitantDoctorDetails: healthRecordsReducer,
    dependantDoctorDetails: depHealthReducer,
    yourDependantDetails: YourDependantDetailsReducer,
    applicationDataResponse: ResponseApplicationModalReducer,
    yourProductApplication: YourProductApplicationReducer,
    pensionSavings: pensionSavingsReducer,
    underwritingDataHO: UnderWritingDataReducer,
    guidanceAndAdvice: GuidanceAndAdviceReducer,
    yourLumpSumAllowances: YourLumpSumAllowancesReducer,
    ppList: PensionProvidersListReducer

};

export const metaReducers: MetaReducer<AppState>[] = [clearState];